export const situacaoRequisicao = {
    CADASTRADA: 1,
    DEVOLVIDA_PARA_CORRECAO: 2,
    DEVOLVIDA_PARA_ANALISE: 3,
    DEVOLVIDA_INFORMACOES_INSULFICIENTES: 4,
    CONCLUIDA: 5,
    AUTORIZADA: 10,
    REJEITADA: 11,
    ENVIO_REGISTRADO: 12,
    DEVOLVIDO_FORA_DO_PRAZO: 13,
    DEVOLVIDO_POR_FMO: 14,
    FINALIZADA: 15,
    CANCELADA: 16
}
